import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "src/components/ui/button";
import { AlertTriangle, Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "src/components/ui/dialog";
import { toast } from "sonner";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import { cn } from "../../lib/utils";

export function DialogDelete({
  data,
  title,
  apiUrl,
  fetchData,
  className,
  isDrop,
}) {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axios.delete(`${BaseUrlApi}${apiUrl}`);
      toast.success(`تم حذف ${title} بنجاح`);
      await fetchData();
      setOpen(false);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object")
        toast("Error", {
          description: result,
        });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          size="sm"
          className={cn("rounded-lg px-2 text-red-600", className)}
          variant="ghost"
        >
          {isDrop && "الحذف"} <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md p-6 overflow-hidden" dir="rtl">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="space-y-4"
        >
          <DialogHeader>
            <DialogTitle className="text-right flex items-center gap-2">
              <AlertTriangle className="h-5 w-5" />
              تحذير: هذا الإجراء لا يمكن التراجع عنه
            </DialogTitle>
          </DialogHeader>
          <div className="p-4 bg-red-100 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800/30">
            <p className="text-red-700 dark:text-red-400 !m-0 leading-6">
              أنت على وشك حذف {data || title} نهائيًا. هذا الإجراء لا يمكن
              التراجع عنه وسيؤدي إلى حذف جميع البيانات المرتبطة بهذا{" "}
              {data || title}.
            </p>
          </div>
          <div className="flex justify-between gap-2">
            <DialogClose>
              <Button type="button" variant="outline">
                إلغاء
              </Button>
            </DialogClose>
            <Button
              onClick={handleDelete}
              disabled={isLoading}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              {isLoading ? (
                <span className="flex items-center gap-2">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  جاري الحذف...
                </span>
              ) : (
                <span className="flex items-center gap-2">
                  <Trash2 className="h-4 w-4" />
                  حذف {title} نهائيًا
                </span>
              )}
            </Button>
          </div>
        </motion.div>
      </DialogContent>
    </Dialog>
  );
}
